"use client";

import { useEffect } from "react";

export default function LiveChat() {
  // Ambil dari environment variables
  const tawkId = process.env.NEXT_PUBLIC_TAWK_TO_ID;
  const widgetId = process.env.NEXT_PUBLIC_TAWK_TO_WIDGET;
  const isEnabled = process.env.NEXT_PUBLIC_ENABLE_LIVE_CHAT === "true";

  if (!isEnabled) return null;

  // Validasi jika environment variables tidak ada
  if (!tawkId || !widgetId) {
    console.error(
      "Tawk.to configuration is missing. Check your environment variables.",
    );

    // Fallback ke nilai hardcoded jika di development
    if (process.env.NODE_ENV === "development") {
      console.warn("Using development fallback values for Tawk.to");
    } else {
      // Di production, jangan render apa-apa jika konfigurasi tidak ada
      return null;
    }
  }

  useEffect(() => {
    if (!tawkId || !widgetId) return;
    
    // Prevent double injection
    if (window.Tawk_API && Object.keys(window.Tawk_API).length > 0) return;

    // Delay loading to ensure page is fully interactive and avoid race conditions
    const loadTawk = () => {
      try {
        // Initialize Tawk_API
        window.Tawk_API = window.Tawk_API || {};
        window.Tawk_LoadStart = new Date();

        const script = document.createElement("script");
        script.async = true;
        script.src = `https://embed.tawk.to/${tawkId}/${widgetId}`;
        script.charset = "UTF-8";
        script.setAttribute("crossorigin", "*");
        
        // Error handler for script loading failures
        script.onerror = () => {
          console.error("Failed to load Tawk.to script");
        };
        
        document.body.appendChild(script);
      } catch (error) {
        console.error("Error initializing Tawk.to:", error);
      }
    };

    // Defer loading by 2 seconds to reduce conflicts during initial hydration
    const timerId = setTimeout(loadTawk, 2000);

    return () => {
      clearTimeout(timerId);
    };
  }, [tawkId, widgetId]);

  return null;
}

// Add global type definition for Tawk
declare global {
  interface Window {
    Tawk_API: any;
    Tawk_LoadStart: any;
  }
}
